<script>
import { onMounted, ref, watch } from '@vue/composition-api'
import "vue-croppa/dist/vue-croppa.css";
import { required } from '@/@core/utils/validation';
import adminApi from '@/api/admin';
import router from '@/router';
import { i18n } from "@/plugins/i18n";

export default {
    props: ["screen"],
    setup(props) {
        const weather = ref({
            id: null,
            screen: props.screen,
            city: '',
            latitude: '',
            longitude: ''
        });

        const formRef = ref(null);
        const isSubmitting = ref(false);

        const fetchWeather = async () => {
            const response = await adminApi.getInfoTvScreenWeather(props.screen);
            if (response.ok) {
                weather.value = response.data;
            }
        }

        const submit = async () => {
            const valid = await formRef.value.validate();
            if (valid && !isSubmitting.value) {
                isSubmitting.value = true;

                const weatherData = {
                    id: weather.value.id,
                    screen: props.screen,
                    city: weather.value.city,
                    latitude: null,
                    longitude: null
                }

                if (weather.value.latitude && weather.value.longitude) {
                    weatherData.latitude = Number(weather.value.latitude).toFixed(3);
                    weatherData.longitude = Number(weather.value.longitude).toFixed(3);
                }

                const res = await adminApi.saveInfoTvScreenWeather(props.screen, weatherData);
                if (!res.ok) {
                    alert(res.error);
                }

                setTimeout(() => {
                    isSubmitting.value = false;
                }, 500);
            }
        }

        const deleteWeather = async () => {
            if (confirm(i18n.t('Haluatko varmasti poistaa sään?'))) {
                const res = await adminApi.deleteInfoTvScreenWeather(props.screen, weather.value.id);
                if (res.ok) {
                    router.replace({ name: 'admin-infotv-screens' });
                } else {
                    alert(res.error);
                }
            }
        }



        onMounted(() => {
            fetchWeather();
        })

        return {
            weather,
            required,
            deleteWeather,
            submit,
            formRef,
            isSubmitting,
        }
    }
}

</script>
<template>
    <v-form ref="formRef" v-on:submit.prevent="submit">
        <v-row>
            <v-col>
                <div class="pb-5">
                    Kaupunki tai koordinaatit on pakollinen
                </div>
                <v-text-field v-model="weather.city" :label="$t('Kaupunki')" outlined class="mb-4"
                    :rules="[v => !!v || (!!weather.latitude && !!weather.longitude) || 'Kaupunki tai koordinaatit vaaditaan']"
                    hide-details="auto" />
            </v-col>
        </v-row>
        <v-row style="display: none;">
            <v-col cols="6">
                <v-text-field v-model="weather.latitude" :label="$t('Leveysaste')" outlined class="mb-4"
                    :rules="[v => !v || (!!v && !!weather.longitude) || 'Molemmat koordinaatit vaaditaan']"
                    hide-details="auto" type="number" step="0.001" />
            </v-col>
            <v-col cols="6">
                <v-text-field v-model="weather.longitude" :label="$t('Pituusaste')" outlined class="mb-4"
                    :rules="[v => !v || (!!v && !!weather.latitude) || 'Molemmat koordinaatit vaaditaan']"
                    hide-details="auto" type="number" step="0.001" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>

                <v-btn type="submit" color="primary" class="mr-3" :loading="isSubmitting">
                    {{ $t('Tallenna') }}
                </v-btn>
                <v-btn @click="deleteWeather" color="error" class="mr-3" v-if="weather.id">
                    {{ $t('Poista') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
</template>
